import {
  SEARCH_GROUP_ERROR,
  SEARCH_GROUP_START,
  SEARCH_GROUP_SUCCESS,
} from 'constants/action-types/organizations/searchGroup';

export default (state, { type, payload }) => {
  switch (type) {
    case SEARCH_GROUP_START:
      return {
        ...state,
        searchGroup: {
          ...state.searchGroup,
          loading: true,
          error: null,
        },
      };
    case SEARCH_GROUP_ERROR:
      return {
        ...state,
        searchGroup: {
          ...state.searchGroup,
          error: payload,
          loading: false,
        },
      };
    case SEARCH_GROUP_SUCCESS:
      return {
        ...state,
        searchGroup: {
          ...state.searchGroup,
          meta: payload.meta,
          loading: false,
          items: payload.data,
        },
      };
    default:
      return null;
  }
};
